module.exports = __webpack_public_path__ + "media/images/winner--left-e10c71e2de711cccc7612e4e3fe92fdf.png";